import type { FC } from 'react';
import { Card, Flex, Typography } from 'antd';
import type { DropOffCausesCardViewModel } from '../../ServiceQualityPage.types';

const { Text } = Typography;

export interface DropOffCausesCardProps {
  card: DropOffCausesCardViewModel;
}

export const DropOffCausesCard: FC<DropOffCausesCardProps> = ({ card }) => {
  return (
    <Card className="om-kpi-card" styles={{ body: { padding: 20 } }}>
      <Flex vertical gap={12} style={{ height: '100%' }}>
        <Text className="ds-card-label">{card.title}</Text>
        <Text className="ds-kpi-value om-kpi-card__metric">{card.metric}</Text>
        <Flex vertical gap={10} className="sq-dropoff-bars">
          {card.bars.map((bar) => (
            <div key={bar.id} className="sq-dropoff-bars__row">
              <Flex justify="space-between" align="center">
                <Text className="sq-dropoff-bars__label">{bar.label}</Text>
                <Text className="sq-dropoff-bars__percent">
                  {bar.percentLabel}
                </Text>
              </Flex>
              <div className="sq-dropoff-bars__track" role="presentation">
                <div
                  className="sq-dropoff-bars__fill"
                  style={{ width: `${bar.percent}%` }}
                />
              </div>
            </div>
          ))}
        </Flex>
      </Flex>
    </Card>
  );
};
